import { Card, CardContent } from "@mui/material";

import Info from "../Info";
import { useContent } from "../../content/useContent";
import { getDateWithoutSeconds } from "../../utils/getDateWithoutSeconds";

type IProps = {
  row: any;
};

const ListItem: React.FC<IProps> = ({ row }) => {
  const { pages } = useContent();
  const { pushNotifications } = pages;
  return (
    <Card>
      <CardContent sx={{ pt: 1, pr: 1 }}>
        <Info title={pushNotifications.id} description={row.id} my={1} />
        <Info
          title={pushNotifications.message}
          description={row.message}
          my={1}
        />
        <Info
          title={pushNotifications.dateSent}
          description={`${getDateWithoutSeconds(row.dateSent)}`}
          my={1}
        />
      </CardContent>
    </Card>
  );
};

export default ListItem;
